import React from 'react';

const InfoDisplayGrid = ({
  children,
  gridSize = { xs: '12', md: '3', lg: '4' },
}) => {
  return (
    <div className='d-flex flex-row flex-wrap info-display-grid'>
      {children.length > 0 &&
        children.map((child, index) => (
          <div
            key={index}
            className={`col-${gridSize.xs} col-md-${gridSize.md} col-lg-${gridSize.lg} d-flex flex-column info-card-container px-0`}
          >
            <div className='d-flex flex-column flex-grow-1 info-card'>
              {child}
            </div>
          </div>
        ))}
    </div>
  );
};

export default InfoDisplayGrid;
